/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class LayersAlt extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" version="1">
        <path
          fill="none"
          stroke="#f66164"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M18 26.066L2 33l30 12 30-12-16-6.933"
        />
        <path
          fill="none"
          stroke="#f66164"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M18 39.066L2 46l30 12 30-12-16-6.933M32 32l30-12L32 7 2 20z"
        />
      </svg>
    );
  }
}

export default LayersAlt;



// WEBPACK FOOTER //
// ./src/routes/home/img/icons/LayersAlt.js